// theme constant
export const gridSpacing = 1;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const operatorTypes = [
	{ type: 'equal' },
	{ type: 'notEqual' },
	{ type: 'pattern' },
	{ type: 'isNotEmpty' },
	{ type: 'isEmpty' },
	{ type: 'greaterThan' },
	{ type: 'greaterThanInclusive' },
	{ type: 'lessThan' },
	{ type: 'lessThanInclusive' },
	{ type: 'contains' },
	{ type: 'doesNotContain' },
];

export const ruleOperatorTypes = {
	array: ['contains', 'doesNotContain', 'isNotEmpty', 'isEmpty', 'inArray', 'notInArray'],
	object: [
		'looseEqual',
		'equal',
		'notEqual',
		'greaterThan',
		'greaterThanInclusive',
		'lessThan',
		'lessThanInclusive',
		'pattern',
		'isNotEmpty',
		'isEmpty',
		'in',
		'notIn',
		'isLike',
		'notLike',
	],
	column: [
		'looseEqual',
		'equal',
		'notEqual',
		'greaterThan',
		'greaterThanInclusive',
		'lessThan',
		'lessThanInclusive',
		'pattern',
		'isNotEmpty',
		'isEmpty',
		'in',
		'notIn',
		'isLike',
		'notLike',
	],
	default: [
		'looseEqual',
		'equal',
		'notEqual',
		'greaterThan',
		'greaterThanInclusive',
		'lessThan',
		'lessThanInclusive',
		'pattern',
		'isNotEmpty',
		'isEmpty',
		'in',
		'notIn',
		'isLike',
		'notLike',
	],
};
